export default "__VITE_ASSET__4ed36ea1__"